import React, { useContext, useEffect, useState } from "react";
import InputRegister from "../../../../blocks/ui/InputRegister";
import SelectInputWithSearch from "../../../../blocks/ui/SelectInputWithSearch";
import { IoMdAdd } from "react-icons/io";
import { FiEdit2 } from "react-icons/fi";
import { MdDeleteOutline } from "react-icons/md";
import experienceJson from '../../../../../data/experience.json'
import jobTitles from "../../../../../data/jobTitles.json";
import industryTypes from "../../../../../data/industryTypes.json";
import { Layout } from "./Layout";
import { isNumericString, validateExperience } from "../../../../../utils/validator";
import { DContext } from "../../../../../context/Datacontext";
import { createExperience } from "../../../../services/Candidate/Profile/Experiemce/createExperience";
import { updateExperience } from "../../../../services/Candidate/Profile/Experiemce/updateExperience";
import { deleteExperience } from "../../../../services/Candidate/Profile/Experiemce/deleteExperience";
import SelectInput from "../../../../blocks/ui/SelectInput";
import PreferrenceJson from "../../../../../data/skills.json";
import { useLocation, useNavigate } from "react-router-dom";
import { apiFetch } from "../../../../services/fetchApi";


const makeEmptySkill = () => ({
    jobTitle: "",
    employer: "",
    employmentType: "",
    workMode: "",
    industryType: "",
    noticePeriod: "",
    periodFrom: ["", "", ""],
    periodTo: ["", "", ""],
    isOngoing: false,
    location: "",
    city: "",
    state: "",
    country: "",
    description: "",
    isFresher: false
});

export const Experience = ({ candidate, fetchCandidateData }) => {
    const { BeURL, formatPeriod, currentUser, showAlert, } = useContext(DContext)
    const [experiences, setExperiences] = useState([]);
    const [topInput, setTopInput] = useState(makeEmptySkill());
    const [editingCardId, setEditingCardId] = useState(null);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const navigate = useNavigate()
    const [totalExp, setTotalExp] = useState({
        year: "",
        month: ""
    })

    // fetch the query:;

    const location = useLocation()
    const queryFetch = new URLSearchParams(location.search)
    const reverse = queryFetch.get('inverse') === "true"
    const previous = location.state?.from || '/account'
    const active = location.state?.active || 'Overview'



    const [isFresher, setIsFresher] = useState(false);

    useEffect(() => {
        fetchCandidateData()
    }, [])

    const mandatory = {
        jobTitle: true,
        employer: true,
        // city: true,
        // state: true,
        // industryType: true,
        // periodFromYear: true,
        noticePeriod: true,
        periodToYear: !topInput.isOngoing
    }

    useEffect(() => {
        if (Array.isArray(candidate?.experiences)) {
            setExperiences(candidate?.experiences);
        }
        if (candidate?.experience) {
            setTotalExp({
                month: candidate?.experience?.month || "",
                year: candidate?.experience?.year || ""
            })
        }
    }, [candidate?.experiences, candidate?.experience]);

    const handleToggle = () => {
        setIsFresher(prev => {
            const newValue = !prev;
            setTopInput(prevInput => ({ ...prevInput, isFresher: newValue }));
            return newValue;
        });
    };
    
    const handleTopFieldChange = (field, value) => {
        setTopInput(prev => ({ ...prev, [field]: value }));
        setTouched(prev => ({ ...prev, [field]: true }));
        setErrors(prev => ({ ...prev, [field]: undefined })); // clear error on change
        if (field === "periodFrom") setErrors(prev => ({ ...prev, periodFromYear: undefined }));
        if (field === "periodTo") setErrors(prev => ({ ...prev, periodToYear: undefined }));

    };

    useEffect(() => {
        if (!validateExperience(topInput, setErrors, isFresher)) return
    }, [isFresher])

    const handleTopAdd = () => {
        setTouched(mandatory)
        if (!validateExperience(topInput, setErrors, isFresher)) return
        createExperience({ BeURL, experience: [topInput], setExperiences, candidateId: candidate._id, showAlert })
        handleTopClear()
    };

    const handleTopUpdate = (id) => {
        setTouched(mandatory)
        if (!validateExperience(topInput, setErrors, isFresher)) return
        setExperiences(prev =>
            prev.map(c => (c.id === editingCardId ? { ...c, ...topInput, id: c.id } : c))
        );
        updateExperience({ BeURL, id, experience: [topInput], candidateId: candidate._id, showAlert })
    };

    const handleTopClear = () => {
        setTopInput(makeEmptySkill());
        setErrors({});
        setTouched({});
        setEditingCardId(null);
    };

    const handleCardDelete = (id) => {
        if (!id) {
            alert("Experience ID missing!");
            return;
        }
        const confirmDelete = window.confirm("Are you sure you want to delete this experience?");
        if (confirmDelete) {
            setExperiences(prev => prev.filter(exp => exp._id !== id))
            deleteExperience({ BeURL, id, candidateId: candidate._id, showAlert })
            handleTopClear()

        }
    };

    const handleCardEdit = (idx) => {
        const card = experiences[idx];
        if (!card) return;

        const normalizePeriod = (isoDateStr) => {
            if (!isoDateStr) return ["", "", ""];
            const date = new Date(isoDateStr);
            const year = date.getFullYear().toString();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");

            return [
                year,
                month === "01" && day === "01" ? "" : month,
                month === "01" && day === "01" ? "" : day,
            ];
        };

        const experience = {
            ...card,
            periodFrom: normalizePeriod(card.periodFrom),
            periodTo: normalizePeriod(card.periodTo),
            year: normalizePeriod(card.periodFrom)[0],
            month: normalizePeriod(card.periodFrom)[1],
            date: normalizePeriod(card.periodFrom)[2],
            city: card.city || "",
            country: card.country || "",
            description: card.description || "",
            employer: card.employer || "",
            employmentType: card.employmentType || "",
            workMode: card.workMode || "",
            industryType: card.industryType || "",
            isFresher: card.isFresher || "",
            isOngoing: card.isOngoing || false,
            jobTitle: card.jobTitle || "",
            location: card.location || "",
            noticePeriod: card.noticePeriod || "",
            state: card.state || "",
            _id: card._id
        };

        setTopInput({
            ...experience,
        });
        setIsFresher(experience.isFresher)

        setEditingCardId(experience._id); // experience-level id
        setErrors({});
        setTouched({});
    };

    const handleSubmit = () => {

        if ((experiences && experiences.length > 0 && (experiences.length > 0 && (totalExp.year || totalExp.month))) || isFresher) {
         
            if (reverse)
                navigate(previous, { state: { active } })

            else {
                const confirmed = window.confirm("Are you sure you want to go to Preferences?");
                if (!confirmed) return;
                console.log("Are you sure you want to go to Preferences?")
                navigate(`/update-account/preferences?candidateId=${candidate?._id}`);
            }

        } else {

            showAlert("Please add at least one experience detail before proceeding. If you are a fresher, toggle the switch and click the Add button. (or) Total Experience is required");
        }
    };


    const handleExperience = () => {
        if (!totalExp) {
            showAlert("Kindly provide Total Experience!")
            return

        }
        if (totalExp.year || totalExp.month) {

            if (totalExp.year && typeof totalExp.year !== "number" && !isNumericString(totalExp.year)) {
                showAlert("Kindly provide a valid year!")
                return
            }

            if (totalExp.month && typeof totalExp.month !== "number" && !isNumericString(totalExp.month)) {
                showAlert("Kindly provide a valid month!")
                return
            }
            // console.log("totalExp", totalExp)
            apiFetch(`${BeURL}/update-total-exp`, {
                method: 'POST',
                // headers: {
                //     "Content-type": "application/json",

                // },

                body: JSON.stringify({ year: totalExp.year, month: totalExp.month, candidateId: candidate._id })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.success === false) {
                        showAlert(data.message)
                        return
                    }
                    else {
                        showAlert(data.message)
                    }
                })
        }
    }

    const handleTotalExp = (e, label) => {
        const { value } = e.target
        // console.log(label)
        const regex = /^[0-9]+$/;
        if (regex.test(value) || value === "") {
            if (label === "month" && value !== "" && Number(value) > 11) {
                return; // stop here
            }
            setTotalExp({ ...totalExp, [label]: value })
        }

    }

    return (
        <Layout candidate={candidate}>
            <section className="max-w-7xl mx-auto w-full py-4 mb-20">
                <div className="">

                    <div className="border-2 rounded-xl p-4 bg-white shadow-sm mb-4">
                        <h5 className="text-sm font-medium text-slate-800">Total Experience</h5>
                        <div className="flex gap-3 my-2">
                            <div className="flex flex-col gap-2">
                                <label className="text-sm font-medium text-slate-800" htmlFor="exp-y">Year (s){!isFresher && <sup className="text-red-500 text-base">*</sup>}</label>
                                <input value={totalExp.year} onChange={e => handleTotalExp(e, "year")} pattern="[0-9]+" id="exp-y" placeholder="Eg: 4" className="px-3 py-2 rounded-lg border" type="tel"></input>
                            </div>

                            <div className="flex flex-col gap-2">
                                <label className="text-sm font-medium text-slate-800" htmlFor="exp-m">Month (s){!isFresher && <sup className="text-red-500 text-base">*</sup>}</label>
                                <input value={totalExp.month} onChange={e => handleTotalExp(e, "month")} maxLength={2} pattern="[0-9]+" id="exp-m" placeholder="Eg: 6" className="px-3 py-2 rounded-lg border" type="tel"></input>

                            </div>
                            <div className="flex items-end">
                                <button title="add" type="button" onClick={handleExperience} className="px-3 rounded-lg bg-primary-400 text-white flex items-center justify-center shadow-md">
                                    <IoMdAdd size={20} />
                                    <span className="hidden md:block">{candidate.experience ? 'Update' : 'Add'}</span>
                                </button>
                            </div>

                        </div>
                    </div>

                    {/* Top Input Panel */}
                    <div className="border-2 rounded-2xl p-4 bg-white shadow-sm mb-4">
                        <div className="flex items-center gap-3 justify-center">
                            {/* Experienced text */}
                            <span
                                className={`${!isFresher ? "text-primary-500 font-bold" : "text-gray-400"
                                    }`}
                            >
                                Experienced
                            </span>

                            {/* Toggle button */}
                            <button
                                onClick={handleToggle}
                                className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${isFresher
                                    ? "bg-secondary-500 justify-end"
                                    : "bg-primary-500 justify-start"
                                    }`}
                            >
                                <div className="w-5 h-5 bg-white rounded-full shadow-md"></div>
                            </button>

                            {/* Fresher text */}
                            <span
                                className={`${isFresher ? "text-secondary-500 font-bold" : "text-gray-400"
                                    }`}
                            >
                                No, I'm a Fresher
                            </span>
                        </div>

                        {/* Inputs Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-3 md:gap-1 mt-[8px]">
                            {/* Job Title */}
                            <SelectInputWithSearch
                                label="Job Title"
                                mandatory={!isFresher && true}
                                value={topInput.jobTitle}
                                onChange={e => handleTopFieldChange("jobTitle", e.target.value)}
                                options={jobTitles.jobTitle}
                                placeholder="Job title"
                                className={`w-full ${errors.jobTitle && touched.jobTitle ? "border-red-500" : ""}`}
                                error={errors.jobTitle && touched.jobTitle ? errors.jobTitle : ""}
                                border={true}
                            />

                            {/* Company Name */}
                            <InputRegister
                                label="Company Name"
                                mandatory={!isFresher && true}

                                value={topInput.employer}
                                onChange={e => handleTopFieldChange("employer", e.target.value)}
                                placeholder="Company Name"

                                type="text"
                                className={`w-full ${errors.employer && touched.employer ? "border-red-500" : ""}`}
                                error={errors.employer && touched.employer ? errors.employer : ""}
                                border={true}
                            />

                            {/* Employment Type */}
                            <SelectInput
                                label="Employment Type"
                                // mandatory
                                value={topInput.employmentType}
                                onChange={e => handleTopFieldChange("employmentType", e.target.value)}
                                options={experienceJson.employeementType}
                                placeholder="Employment Type"
                                error={errors.employmentType && touched.employmentType ? errors.employmentType : ""}
                                className={`w-full ${errors.employmentType && touched.employmentType ? "border-red-500" : ""}`}
                                border={true}
                            />

                            {/* Employment Mode */}
                            <SelectInput
                                label="Work Mode"
                                // mandatory
                                value={topInput.workMode}
                                onChange={e => handleTopFieldChange("workMode", e.target.value)}
                                options={experienceJson.workMode}
                                placeholder="Work Mode"
                                error={errors.workMode && touched.workMode ? errors.workMode : ""}
                                className={`w-full ${errors.workMode && touched.workMode ? "border-red-500" : ""}`}
                            />

                            {/* Industry Type */}
                            <SelectInputWithSearch
                                label="Industry Type"
                                // mandatory
                                value={topInput.industryType}
                                onChange={e => handleTopFieldChange("industryType", e.target.value)}
                                options={industryTypes.industryTypes}
                                placeholder="Industry Type"

                                className={`w-full ${errors.industryType && touched.industryType ? "border-red-500" : ""}`}
                                error={errors.industryType && touched.industryType ? errors.industryType : ""}
                                border={true}
                            />
                            <InputRegister
                                label={"Location"}
                                value={topInput.location}
                                name="lastUsed"
                                onChange={(e) => handleTopFieldChange("location", e.target.value)}
                                placeholder="Location"

                                type="text"
                                className={"w-full"}
                                border={true}
                            />
                            <InputRegister
                                label={"City"}
                                value={topInput.city}
                                // mandatory={!isFresher && true}

                                name="lastUsed"
                                onChange={(e) => handleTopFieldChange("city", e.target.value)}
                                placeholder="City"

                                type="text"
                                className={"w-full"}
                                // error={errors.city && touched.city ? errors.city : ""}
                                border={true}
                            />
                            <InputRegister
                                label={"State"}
                                value={topInput.state}
                                name="lastUsed"
                                onChange={(e) => handleTopFieldChange("state", e.target.value)}
                                placeholder="State"
                                // mandatory={!isFresher && true}

                                type="text"
                                className={"w-full"}
                                border={true}
                            // error={errors.state && touched.state ? errors.state : ""}

                            />
                            <InputRegister
                                label={"Country"}
                                value={topInput.country}
                                name="lastUsed"
                                onChange={(e) => handleTopFieldChange("country", e.target.value)}
                                placeholder="Country"
                                type="text"
                                className={"w-full"}
                                border={true}
                            />

                            {/* Start Date */}
                            <div>
                                <label className="text-sm text-slate-600 font-semibold">Year of Start</label>
                                <div className="flex gap-2 mt-2 items-center">
                                    <div>
                                        <select
                                            value={topInput.periodFrom[0]}
                                            onChange={e => {
                                                const newDate = [...topInput.periodFrom];
                                                newDate[0] = e.target.value;
                                                handleTopFieldChange("periodFrom", newDate);
                                            }} shadow
                                            className={`w-20 h-11 text-center border rounded-lg ${errors.periodFromYear && touched.periodFromYear ? "border-red-500" : "border-gray-300"}`}
                                        >
                                            <option value="">YYYY</option>
                                            {Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i).map(y => (
                                                <option key={y} value={y}>{y}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Month Dropdown */}
                                    {
                                        topInput.periodFrom[0] &&
                                        <div>

                                            <select
                                                value={topInput.periodFrom[1] || ""}
                                                onChange={(e) => {
                                                    const newDate = [...topInput.periodFrom];
                                                    newDate[1] = e.target.value;
                                                    handleTopFieldChange("periodFrom", newDate);
                                                }} shadow
                                                className="w-16 h-11 text-center border rounded-lg"
                                            >
                                                <option value="">MM</option>
                                                {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                                                    <option key={month} value={month.toString().padStart(2, "0")}>
                                                        {month.toString().padStart(2, "0")}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    }
                                    {/* Day Dropdown */}
                                    {topInput.periodFrom[1] &&
                                        <div>

                                            <select
                                                value={topInput.periodFrom[2]}
                                                onChange={(e) => {
                                                    const newDate = [...topInput.periodFrom];
                                                    newDate[2] = e.target.value;
                                                    handleTopFieldChange("periodFrom", newDate);
                                                }}
                                                className="w-16 h-11 text-center border rounded-lg"
                                            >
                                                <option value="">DD</option>
                                                {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                                                    <option key={day} value={day.toString().padStart(2, "0")}>
                                                        {day.toString().padStart(2, "0")}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    }
                                </div>
                                {errors.periodFromYear && touched.periodFromYear && (
                                    <p className="text-red-500 text-xs mt-2">{errors.periodFromYear}</p>
                                )}
                            </div>

                            {/* End Date */}
                            {!topInput.isOngoing && (
                                <div>
                                    <label className="text-sm text-slate-600 font-semibold">Year of End{!isFresher && <sup className="text-red-500 text-base">*</sup>}</label>
                                    <div className="flex gap-2 items-center">
                                        <div>

                                            {/* <select
                                                value={topInput.periodTo[0]}
                                                onChange={e => {
                                                    const newDate = [...topInput.periodTo];
                                                    newDate[0] = e.target.value;
                                                    handleTopFieldChange("periodTo", newDate);
                                                }}
                                                className={`my-2 w-20 h-11 text-center border rounded-lg ${errors.periodToYear && touched.periodToYear ? "border-red-500" : "border-gray-300"}`}
                                            >
                                                <option value="">YYYY</option>
                                                {Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i).map(y => (
                                                    <option key={y} value={y} disabled={y < Number(topInput.periodFrom[0])}>{y}</option>
                                                ))}
                                            </select> */}
                                            <select
                                                value={topInput.periodTo[0]}
                                                disabled={topInput.isOngoing}
                                                onChange={e => {
                                                    const newDate = [...topInput.periodTo];
                                                    newDate[0] = e.target.value;
                                                    handleTopFieldChange("periodTo", newDate);
                                                }}
                                                className={`w-20 h-11 text-center border rounded-lg ${!topInput.isOngoing
                                                    ? errors.periodToYear && touched.periodToYear
                                                        ? "border-red-500"
                                                        : "border-gray-300"
                                                    : ""
                                                    }`}
                                            >
                                                <option value="">YYYY</option>

                                                {(() => {
                                                    const currentYear = new Date().getFullYear();
                                                    const years = [];

                                                    // 20 years past → 30 years future
                                                    for (let i = -20; i <= 30; i++) {
                                                        years.push(currentYear + i);
                                                    }

                                                    return years.map(y => (
                                                        <option
                                                            key={y}
                                                            value={y}
                                                            disabled={Number(y) < Number(topInput.periodFrom[0])}
                                                        >
                                                            {y}
                                                        </option>
                                                    ));
                                                })()}
                                            </select>

                                        </div>

                                        {/* Month Dropdown */}
                                        {topInput.periodTo[0] &&
                                            <div>
                                                <select
                                                    value={topInput.periodTo[1] || ""}
                                                    onChange={(e) => {
                                                        const newDate = [...topInput.periodTo];
                                                        newDate[1] = e.target.value;
                                                        handleTopFieldChange("periodTo", newDate);
                                                    }}
                                                    className="my-2 w-16 h-11 text-center border rounded-lg"
                                                >
                                                    <option value="">MM</option>
                                                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                                                        <option key={month} value={month.toString().padStart(2, "0")}
                                                            disabled={(Number(topInput.periodTo[0]) === Number(topInput.periodFrom[0])) && month < Number(topInput.periodFrom[1])}>
                                                            {month.toString().padStart(2, "0")}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        }
                                        {/* Day Dropdown */}
                                        {topInput.periodTo[1] &&
                                            <div>

                                                <select
                                                    value={topInput.periodTo[2]}
                                                    onChange={(e) => {
                                                        const newDate = [...topInput.periodTo];
                                                        newDate[2] = e.target.value;
                                                        handleTopFieldChange("periodTo", newDate);
                                                    }}
                                                    className="my-2 w-16 h-11 text-center border rounded-lg"
                                                >
                                                    <option value="">DD</option>
                                                    {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                                                        <option key={day} value={day.toString().padStart(2, "0")}
                                                            disabled={(Number(topInput.periodTo[1]) === Number(topInput.periodFrom[1])) && day < Number(topInput.periodFrom[2])}>
                                                            {day.toString().padStart(2, "0")}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        }
                                    </div>
                                    {errors.periodToYear && touched.periodToYear && (
                                        <p className="text-red-500 text-xs mt-2">{errors.periodToYear}</p>
                                    )}

                                </div>
                            )}

                            {/* Is Ongoing */}
                            <div className="flex items-center gap-2 my-2">
                                <input
                                    type="checkbox"
                                    checked={topInput.isOngoing}
                                    onChange={e => handleTopFieldChange("isOngoing", e.target.checked)}
                                    className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                                />
                                <span className="text-gray-700 text-sm">Still Working</span>
                            </div>

                            {topInput.isOngoing && (
                                <SelectInput
                                    label={"Notice Period"}
                                    mandatory={!isFresher ? true : false}
                                    value={topInput.noticePeriod}
                                    onChange={(e) => handleTopFieldChange("noticePeriod", e.target.value)}
                                    options={PreferrenceJson.NoticePeriod}
                                    placeholder="Select Grade Type"
                                    error={errors.noticePeriod && touched.noticePeriod ? errors.noticePeriod : ""}
                                    className={"w-full"}
                                />
                            )}

                            {/* Description */}
                            <div className="flex flex-col gap-1 md:col-span-3">
                                <label className="text-sm text-slate-600 font-semibold">Description</label>
                                <textarea
                                    value={topInput.description}
                                    onChange={e => handleTopFieldChange("description", e.target.value)}
                                    placeholder="Enter description..."
                                    className="w-full p-2 placeholder:text-sm border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    rows={4}
                                />
                            </div>
                        </div>
                        <div className="flex items-center gap-2 justify-end mt-[8px]">
                            {editingCardId ? (
                                <div className="flex gap-3">
                                    <button type="button" onClick={handleTopClear} className="px-3 py-1 rounded underline  font-semibold text-primary-500 flex items-center justify-center text-base">
                                        Clear
                                    </button>
                                    <button title="update" onClick={() => handleTopUpdate(editingCardId)} className=" px-1 w-[70px] md:w-[80px] rounded-lg bg-primary-400 font-semibold text-white flex items-center justify-center shadow-md">
                                        Update
                                    </button>
                                </div>
                            ) : (
                                <div className="flex gap-2">
                                    <button onClick={handleTopClear} className="px-3 py-1 rounded underline  font-semibold text-primary-500 flex items-center justify-center text-base">
                                        Clear
                                    </button>
                                    <button title="add" type="button" onClick={handleTopAdd} className=" px-1 w-[70px] md:w-[80px] rounded-lg bg-primary-400 font-semibold text-white flex items-center justify-center shadow-md">
                                        Add
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* Experiences List */}
                    <div className="mt-3 space-y-4 bg-white rounded-2xl px-4 py-3 w-full">
                        <p>
                            Experience <span>({experiences.length})</span>
                        </p>
                        {experiences.length === 0 && (
                            <div className="text-sm text-gray-400 italic">
                                No experience details added yet. Enter the candidate’s experience above.
                            </div>
                        )}

                        {/* scroll wrapper with buttons */}
                        <div className="relative">
                            {/* Scrollable cards */}
                            <div
                                id="expScroll"
                                className="flex gap-4 overflow-x-auto px-6 py-2"
                            >
                                {experiences.map((card, idx) => (
                                    <div
                                        key={idx}
                                        className={`bg-white rounded-lg flex-shrink-0 shadow-lg p-4 w-full sm:w-[48%] md:w-[30%] ${(card.jobTitle && card.employer) ? 'block' : 'hidden'}`}
                                    >
                                        {/* Header: Job Title + Actions */}
                                        <div className="flex justify-around items-start mb-2">
                                            <div>
                                                <p className="text-xs text-slate-400">Job title</p>
                                                <p className="font-medium text-slate-800 capitalize">
                                                    {card.jobTitle || "-"}
                                                </p>
                                            </div>
                                            <div className="flex gap-2">
                                                <button
                                                    onClick={() => handleCardEdit(idx)}
                                                    className="text-slate-600 p-1 hover:text-blue-600"
                                                    title="Edit"
                                                >
                                                    <FiEdit2 />
                                                </button>
                                                <button
                                                    onClick={() => handleCardDelete(card._id)}
                                                    className="text-red-500 p-1 hover:text-red-700"
                                                    title="Delete"
                                                >
                                                    <MdDeleteOutline />
                                                </button>
                                            </div>
                                        </div>

                                        {/* Company Name */}
                                        <div className="mt-2">
                                            <p className="text-xs text-slate-400">Company name</p>
                                            <p className="text-slate-700 capitalize">{card.employer || "-"}</p>
                                        </div>

                                        {/* Date */}
                                        <div className="flex justify-between">
                                            <div className="mt-2">
                                                <p className="text-xs text-slate-400">Period from</p>
                                                <p className="text-slate-700">
                                                    {(() => {
                                                        const p = formatPeriod(card.periodFrom);
                                                        return `${p.date ? p.date + " " : ""}${p.month ? p.month + " " : ""}${p.year || "-"}`;
                                                    })()}
                                                </p>
                                            </div>
                                            <div className="mt-2">
                                                <p className="text-xs text-slate-400">Period to</p>
                                                <p className="text-slate-700">
                                                    {(() => {
                                                        const p = formatPeriod(card.periodTo);
                                                        return `${p.date ? p.date + " " : ""}${p.month ? p.month + " " : ""}${p.year || "-"}`;
                                                    })()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="flex justify-end mt-1 items-center gap-2">
                                {/* hint text */}
                                <p className="text-[10px] text-slate-400 italic">
                                    Use ← and → buttons to scroll
                                </p>
                                {/* Left button */}
                                <button
                                    onClick={() => {
                                        document.getElementById("expScroll").scrollBy({ left: -200, behavior: "smooth" });
                                    }}
                                    className=" bg-white shadow rounded-full p-1 text-xs"
                                >
                                    ◀
                                </button>
                                {/* Right button */}
                                <button
                                    onClick={() => {
                                        document.getElementById("expScroll").scrollBy({ left: 200, behavior: "smooth" });
                                    }}
                                    className="  bg-white shadow rounded-full p-1 text-xs"
                                >
                                    ▶
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row justify-between items-center gap-4 my-2 w-full">
                    {/* Back Button */}
                    <button onClick={() => navigate(`/update-account/education?candidateId=${candidate?._id}`)}
                        className="w-full sm:w-auto border border-primary-500 text-primary-500 px-4 py-2 rounded-xl font-medium  transition text-center">
                        Previous
                    </button>

                    {/* Complete Button */}
                    <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={!isFresher && experiences.length === 0}
                        className={`w-full sm:w-auto ${experiences.length > 0 || isFresher ? "bg-[#2C25C4] cursor-pointer" : "bg-slate-400"} text-white px-4 py-2 rounded-xl font-semibold shadow-md hover:opacity-90 transition text-center`}
                    >
                        {reverse ? 'Update' : 'Next'}
                    </button>
                </div>
            </section>
        </Layout>
    );
};
